// extracted by mini-css-extract-plugin
export default {"star":"CardStar_star__4+XJn"};